<template>
    <!-- 检测记录-查看报告-文字检测修改 -->
    <el-dialog
        title="修改"
        :visible.sync="dialogVisible"
        width="970px"
        :close-on-click-modal="false"
        :close-on-press-escape="false"
        append-to-body
        :before-close="handleClose"
        top="8vh"
    >
        <div
            v-loading="loading"
            class="modify-word-container"
            element-loading-text="拼命加载中"
            element-loading-background="rgba(255,255,255,0)"
        >
            <div class="modify-word-item">
                <div class="modify-word-title">检测时标题：</div>
                <span v-html="subject"></span>
            </div>
            <div class="modify-word-item">
                <div class="modify-word-title">现标题：</div>
                <el-input style="flex: 1" v-model="Subjecttext" placeholder="请输入内容" size="small" />
            </div>
            <div v-if="DetailFwImage.length" class="modify-word-item" style="align-items: flex-start">
                <!-- <div class="modify-word-item"> -->
                <div class="modify-word-title mt5">违禁词：</div>
                <div class="dfc" style="flex: 1; flex-wrap: wrap">
                    <span>代码：</span
                    ><span v-for="(item, index) in DetailFwImage" :key="index" class="tags">{{ item.name }}</span>
                    <span v-if="codeListBanShow" class="ml10 blue curp" @click="codeListBan">一键清除</span
                    ><span v-else class="ml10 gray curp">清除完毕</span>
                </div>
            </div>

            <div class="modify-word-item" v-if="row.hasAttribute" style="align-items: flex-start">
                <div class="modify-word-title mt5">属性：</div>
                <el-table
                    :data="fwAttributeData"
                    style="width: 100%"
                    :header-cell-style="tableHeader"
                    max-height="180px"
                    size="mini"
                    border
                >
                    <el-table-column label="属性名称" align="center" header-align="center">
                        <template #default="{ row }">
                            <span>{{ row.attributeName }}</span>
                        </template>
                    </el-table-column>
                    <el-table-column label="修改前属性值" align="center" header-align="center">
                        <template #default="{ row }">
                            <el-tooltip class="item" effect="dark" :content="row.value" placement="top">
                                <div style="width: 100%" class="textOver" v-html="row.beforeValue"></div>
                            </el-tooltip>
                        </template>
                    </el-table-column>
                    <el-table-column label="修改后属性值" align="center" header-align="center">
                        <template #default="{ row }">
                            <span>{{ row.afterValue }}</span>
                        </template>
                    </el-table-column>
                    <el-table-column label="操作" align="center" header-align="center">
                        <el-button type="text" size="mini" @click="showModifyAttributes">修改</el-button>
                    </el-table-column>
                </el-table>
            </div>

            <div class="modify-word-item" v-if="row.hasSku" style="align-items: flex-start">
                <div class="modify-word-title mt5">
                    <span>SKU：</span>
                    <el-popover placement="bottom" width="225" trigger="hover" class="curp">
                        <i slot="reference" class="iconfont-npm icon-npm-yiwen color99 mr5" />
                        <div class="color666 font12">只支持对自定义SKU规格值进行修改、删除</div>
                    </el-popover>
                </div>
                <el-table
                    :data="fwSkuData.filter((v) => v.handleType != 1 && v.isShowFw)"
                    style="width: 100%"
                    :header-cell-style="tableHeader"
                    max-height="280px"
                    size="mini"
                    border
                >
                    <el-table-column label="违规SKU名称" align="center" header-align="center">
                        <template #default="{ row }">
                            <span v-html="row.beforeSkuWord.attributeValue"> </span>
                        </template>
                    </el-table-column>
                    <el-table-column label="修改后SKU名称" align="center" header-align="center">
                        <template #default="{ row, $index }">
                            <el-input
                                class="mb5"
                                size="mini"
                                v-model="row.afterSkuWord.attributeValue"
                                @input="changeSku(row, $index)"
                            />
                        </template>
                    </el-table-column>
                    <el-table-column label="删除SKU名称" align="center" header-align="center">
                        <template #default="{ row, $index }">
                            <el-button type="text" size="mini" @click="delSku(row, $index)">删除</el-button>
                        </template>
                    </el-table-column>
                </el-table>
            </div>

            <div v-if="DetailFwText.length" class="modify-word-item" style="align-items: flex-start">
                <div class="modify-word-title mt5">违禁词：</div>
                <div class="dfc" style="flex: 1; flex-wrap: wrap">
                    <span>文字：</span
                    ><a v-for="(item, index) in DetailFwText" :key="index" class="tags" @click="gotoWord(item)">{{
                        item.name
                    }}</a>
                </div>
            </div>
            <div v-if="DetailFw[0]" class="mt15 description">
                <div class="modify-word-title">详情描述：</div>
                <div class="description-code" v-html="description"></div>
                <span id="operation-dom"
                    ><em class="deleteBtn" @click="operate(1)">删除</em
                    ><em class="replaceBtn" @click="operate(2)">替换</em></span
                >
            </div>
        </div>
        <div class="tr mt10">
            <el-button type="primary" size="small" @click="confirm">确 定</el-button>
        </div>
        <ModifyAttributes ref="modifyAttributes" />
    </el-dialog>
</template>
<script>
let operationDom = '';
let id = '';
import { debounce } from 'lodash';
import ModifyAttributes from './modifyAttributes.vue';
export default {
    name: 'ModifyWord',
    components: { ModifyAttributes },
    props: {
        OfferStatu: {
            type: Number,
            required: true,
        },
    },
    data() {
        return {
            dialogVisible: false,
            loading: false,
            row: {}, // 修改的行的数据
            productionInfo: {}, // 接口返回的产品的所有信息
            DetailFwImage: [],
            DetailFwText: [],
            DetailFw: [],
            DetailFwOne: [],
            subject: '', // 原标题
            Subjecttext: '', // 现标题
            subjectArr: [],
            description: '', // 详情
            detailsTextCopy: '',
            tipsObject: [],
            codeListBanShow: true,
            fwAttributeData: [],
            fwSkuData: [],
            tableHeader: {
                background: '#ebecf1',
                color: '#4c4b4b',
                fontSize: '12px',
                fontWeight: 'normal',
            }, // 表头样式
            delSkuArr: [], // 删除sku
            modifyAttributesArr: [],
            fwInfo: {},
        };
    },
    mounted() {
        operationDom = document.querySelector('#operation-dom');
    },
    methods: {
        show(row) {
            this.row = row;
            this.handleData();
            this.getData();
        },
        handleData() {
            this.detailsTextCopy = '';
            let subject = this.row.Subject;
            const subjectArr = (this.row.SubjectFw && this.row.SubjectFw.split('|')) || [];
            for (let i = 0, len = subjectArr.length; i < len; i++) {
                if (subjectArr[i].split(')')[1] === '') {
                    subjectArr[i] = subjectArr[i].split('(')[0];
                }
                if (subject.indexOf(subjectArr[i]) > -1) {
                    subject = subject.replace(subjectArr[i], "<span class='red'>" + subjectArr[i] + '</span>');
                }
            }
            this.subjectArr = subjectArr;
            this.subject = subject;
        },
        getData() {
            const fwWord =
                this.row.SubjectFw + '|' + this.row.DetailFw + '|' + this.row.AttributesFw + '|' + this.row.SkuInfosFw;
            let Words = this.handleFwFunc(fwWord);
            Words = [...new Set(Words)];
            let ajaxData = {
                PlanNo: this.row.PlanNo,
                OfferId: this.row.OfferId,
                FwCheckTypes: this.row.FwCheckTypes,
                Words,
            };
            this.loading = true;
            this.$ajax.post('app/api/to/getgwword', ajaxData).then((res) => {
                this.loading = false;
                if (res.code != 200) {
                    this.$message.warning(res.msg);
                    return;
                }
                this.fwInfo = res.result;
                this.productionInfo = JSON.parse(res.result.productInfoJson);
                this.Subjecttext = this.productionInfo.Subject;
                this.handleFw();
                this.handleSkuFw(res.result.skuInfos);
                this.handleAttributeFw(res.result.productAttribute);
                this.dialogVisible = true;
            });
        },
        // eslint-disable-next-line max-lines-per-function
        handleFwFunc(fwWord) {
            const arr = [];
            fwWord = (fwWord && fwWord.split('|')) || [];
            for (let j = 0, len1 = fwWord.length; j < len1; j++) {
                const item = fwWord[j];
                if (item.split(')')[1] === '') {
                    // "爆款(1)" num = 1,word = "爆款"
                    const start = item.indexOf('(');
                    const word = item.substring(0, start);
                    arr.push(word);
                } else if (item) {
                    arr.push(item);
                }
            }
            return arr;
        },

        // 处理属性违禁词
        handleAttributeFw(productAttribute) {
            const fwAttributeData = productAttribute.map((item) => {
                const attributesFw = (this.row.AttributesFw && this.row.AttributesFw.split('|')) || [];
                const beforeValue = this.highlightFW(item.value, attributesFw);
                return {
                    value: item.value,
                    attributeName: item.attributeName,
                    beforeValue,
                    afterValue: '',
                    attributeID: item.attributeID,
                };
            });
            this.fwAttributeData = fwAttributeData;
        },

        highlightFW(str, replaceArr) {
            for (let i = 0, len = replaceArr.length; i < len; i++) {
                if (replaceArr[i].split(')')[1] === '') {
                    replaceArr[i] = replaceArr[i].split('(')[0];
                }
                if (str.indexOf(replaceArr[i]) > -1) {
                    str = str.replace(new RegExp(replaceArr[i], 'g'), "<span class='red'>" + replaceArr[i] + '</span>');
                }
            }
            return str;
        },

        // 处理sku违禁词
        handleSkuFw(skuInfos) {
            const skuInfosFwArr = (this.row.SkuInfosFw && this.row.SkuInfosFw.split('|')) || [];
            const map = new Map();
            skuInfos.forEach((item) => {
                item.attributes.forEach((el) => {
                    const str = `${el.attributeID}${el.attributeValue}`;
                    const value = map.get(str);
                    if (value) {
                        value.specId.push(item.specId);
                    } else {
                        const attributeValue = this.highlightFW(el.attributeValue, skuInfosFwArr);
                        const obj = {
                            beforeSkuWord: {
                                attributeValue,
                                attributeID: el.attributeID,
                            },
                            afterSkuWord: {
                                attributeValue: '',
                                attributeID: el.attributeID,
                            },
                            specId: [item.specId],
                            handleType: -1, // 操作类型
                            isShowFw: attributeValue !== el.attributeValue, // 只显示有违禁词的sku
                        };
                        map.set(str, obj);
                    }
                });
            });
            let fwSkuData = [...map.values()];
            // // 排序
            // fwSkuData.sort((a, b) => {
            //     if (a.beforeSkuWord.attributeID != b.beforeSkuWord.attributeID) {
            //         return b.beforeSkuWord.attributeID - a.beforeSkuWord.attributeID;
            //     }
            //     return b.beforeSkuWord.attributeID - a.beforeSkuWord.attributeID;
            // });
            this.fwSkuData = fwSkuData;
        },

        // eslint-disable-next-line max-lines-per-function
        handleFw() {
            // 处理违禁词
            this.DetailFw = (this.row.DetailFw && this.row.DetailFw.split('|')) || [];
            const arr = [];
            for (let j = 0, len1 = this.DetailFw.length; j < len1; j++) {
                const item = this.DetailFw[j];
                if (item.split(')')[1] === '') {
                    // "爆款(1)" num = 1,word = "爆款"
                    const start = item.indexOf('(');
                    const num = item.substring(start + 1, item.length - 1) - 0; // 取出括号里的数字
                    const word = item.substring(0, start);
                    arr.push(word);
                    for (var k = 0; k < num; k++) {
                        this.DetailFwOne.push(word);
                    }
                } else if (item) {
                    this.DetailFwOne.push(item);
                    arr.push(item);
                }
            }
            // 标签上的违禁词
            const div = document.createElement('div');
            div.innerHTML = this.productionInfo.Description;
            const imgDom = div.querySelectorAll('img');
            const imgLength = imgDom.length;
            const tipsObject = [];
            let i = 0;
            for (; i < imgLength; i++) {
                const options = {
                    code: '',
                    replaceAfter: '',
                    keys: [],
                    Math: '',
                    type: '',
                    id: '',
                };
                for (let z = 0; z < arr.length; z++) {
                    if (imgDom[i].outerHTML.indexOf(arr[z]) > -1) {
                        options.code = imgDom[i].outerHTML;
                        options.keys.push(arr[z]);
                        options.type = 'img';
                    }
                }
                if (options.code) {
                    options.code = options.code.replace('>', ' />');
                    options.replaceAfter = options.code;
                    tipsObject.push(options);
                }
            }
            let detailsText = this.productionInfo.Description;
            for (let a = 0, tipsLength = tipsObject.length; a < tipsLength; a++) {
                const mathShu = 'div' + Math.floor(Math.random() * 1000000);
                detailsText = detailsText.replace(tipsObject[a].code, mathShu);
                tipsObject[a].Math = mathShu;
            }
            // 文字违禁词
            for (let b = 0; b < this.DetailFwOne.length; b++) {
                const options = {
                    code: '',
                    replaceAfter: '',
                    keys: [],
                    Math: '',
                    type: '',
                    id: '',
                };
                const mathShu = 'div' + Math.floor(Math.random() * 1000000);
                detailsText = detailsText.replace(this.DetailFwOne[b], mathShu);
                options.Math = mathShu;
                options.code = this.DetailFwOne[b];
                options.replaceAfter = this.DetailFwOne[b];
                options.keys.push(this.DetailFwOne[b]);
                options.type = 'text';
                if (options.code) {
                    tipsObject.push(options);
                }
            }
            this.detailsTextCopy = detailsText;
            for (let c = 0; c < tipsObject.length; c++) {
                let textCode;
                if (tipsObject[c].type === 'text') {
                    textCode = `<span class='forbidden-word codeModify' id='text${c}'>${tipsObject[c].code}</span>`;
                    tipsObject[c].id = 'text' + c;
                } else {
                    textCode = `<span class='forbidden-word gulesBor' id='img${c}'>${tipsObject[c].code}</span>`;
                }
                detailsText = detailsText.replace(tipsObject[c].Math, textCode);
            }
            if (arr[0]) {
                for (let d = 0; d < arr.length; d++) {
                    let l1 = 0;
                    let l2 = 0;
                    const index = [];
                    let oneWord = '';
                    for (let f = 0; f < tipsObject.length; f++) {
                        if (tipsObject[f].type === 'text' && arr[d] === tipsObject[f].code) {
                            ++l1;
                            index.push(tipsObject[f].id);
                        } else if (tipsObject[f].type === 'img' && tipsObject[f].code.indexOf(arr[d]) > -1) {
                            oneWord = arr[d];
                            ++l2;
                        }
                    }
                    if (l1) {
                        if (l1 !== 1) {
                            arr[d] = arr[d] + '(' + l1 + ')';
                        }
                        this.DetailFwText.push({
                            name: arr[d],
                            index: index,
                            currIndex: 0,
                        });
                    }
                    if (l2) {
                        if (l2 !== 1) {
                            oneWord = oneWord + '(' + l2 + ')';
                        }
                        this.DetailFwImage.push({
                            name: oneWord,
                        });
                    }
                }
            }
            this.tipsObject = tipsObject;
            this.description = detailsText;
            this.$nextTick(() => {
                if (document.querySelector('.description')) {
                    document.querySelector('.description').addEventListener('mouseover', this.mouseoverEvent, false);
                }
            });
        },
        mouseoverEvent: debounce((e) => {
            // 防抖
            if (!operationDom) {
                operationDom = document.querySelector('#operation-dom');
            }
            const className = e.target.className;
            if (className.includes('forbidden-word')) {
                const left = e.clientX;
                const top = e.clientY;
                operationDom.style.left = left + 'px';
                operationDom.style.top = top + 'px';
                operationDom.style.display = 'block';
                id = e.target.id;
            } else if (className.includes('deleteBtn') || className.includes('replaceBtn')) {
                // do nothing
            } else {
                operationDom.style.display = 'none';
            }
        }, 500),
        operate(index) {
            // index: 1->删除 2->替换
            const i = id.substring(4, id.length);
            if (index === 1) {
                // 删除
                this.tipsObject[i].replaceAfter = '';
                document.querySelector('#' + id).innerText = `被删除(原:${this.tipsObject[i].code})`;
                this.$message.success('删除成功');
            } else {
                // 替换
                this.$prompt('', '替换', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                })
                    .then(({ value }) => {
                        this.tipsObject[i].replaceAfter = value;
                        document.querySelector('#' + id).innerText = `${value}(原:${this.tipsObject[i].code})`;
                    })
                    .catch(() => {});
            }
        },

        confirm() {
            // 确定
            const flag = this.subjectArr != ''; // [""]!="": false;     ["123"]!="" : true
            if (flag) {
                let subjectJudge = false;
                for (let i = 0; i < this.subjectArr.length; i++) {
                    if (this.Subjecttext.indexOf(this.subjectArr[i]) > -1) {
                        subjectJudge = true;
                    }
                }
                if (subjectJudge) {
                    this.$confirm('当前还有违禁词未修改，是否确认当前修改？', '消息', {
                        confirmButtonText: '确定',
                        cancelButtonText: '取消',
                        type: 'warning',
                    })
                        .then(() => {
                            this.handlePostData();
                            this.wordAjax();
                        })
                        .catch(() => {});
                    return;
                }
            }
            this.handlePostData();
            for (let i = 0, len = this.tipsObject.length; i < len; i++) {
                if (
                    this.tipsObject[i].code == this.tipsObject[i].replaceAfter &&
                    !(this.row.DetailFw == '' || this.row.SubjectFw == null)
                ) {
                    this.$confirm('当前还有违禁词未修改，是否确认当前修改？', '消息', {
                        confirmButtonText: '确定',
                        cancelButtonText: '取消',
                        type: 'warning',
                    })
                        .then(() => {
                            this.wordAjax();
                        })
                        .catch(() => {});
                    return;
                }
            }
            this.wordAjax();
        },
        handlePostData() {
            // 处理上传的数据
            // 理论上这里\x20-\xff应该够了 本次改eslint规范 没细看逻辑这里不改
            // eslint-disable-next-line no-control-regex
            if (this.Subjecttext.replace(/[^\x00-\xff]/gi, '--').length > 60) {
                this.$message.warning('标题超出字数限制');
                return;
            }
            let detailsTextCopy = this.detailsTextCopy;
            for (let i = 0, len = this.tipsObject.length; i < len; i++) {
                const math = this.tipsObject[i].Math;
                if (detailsTextCopy.indexOf(math) > -1) {
                    const replaceAfter = this.tipsObject[i].replaceAfter;
                    detailsTextCopy = detailsTextCopy.replace(math, replaceAfter);
                }
            }
            this.detailsTextCopy = detailsTextCopy;
        },

        // 处理提交sku数据
        getSkuParams() {
            this.fwSkuData.forEach((item) => {
                // 修改sku
                if (item.handleType == 0) {
                    item.specId.forEach((el) => {
                        this.fwInfo.skuInfos.forEach((o) => {
                            if (el == o.specId) {
                                o.attributes.forEach((attr) => {
                                    if (attr.attributeID == item.beforeSkuWord.attributeID) {
                                        attr.attributeValue = item.afterSkuWord.attributeValue;
                                    }
                                });
                            }
                        });
                    });
                } else if (item.handleType == 1) {
                    // 删除sku
                    this.delSkuArr = this.fwInfo.skuInfos.filter((sku) => {
                        return item.specId.find((el) => {
                            return el == sku.specId;
                        });
                    });
                    this.fwInfo.skuInfos = this.fwInfo.skuInfos.filter((sku) => {
                        return this.delSkuArr.every((el) => {
                            return el.specId !== sku.specId;
                        });
                    });
                }
            });
        },

        wordAjax() {
            this.getSkuParams();
            const ajaxData = {
                OfferId: this.row.OfferId,
                Subject: this.Subjecttext,
                Description: this.detailsTextCopy,
                OfferStatu: this.OfferStatu,
                PlanNo: this.row.PlanNo,
                Attributes: this.modifyAttributesArr.length ? JSON.stringify(this.modifyAttributesArr) : '',
                SkuInfos: this.fwInfo.skuInfos.length ? JSON.stringify(this.fwInfo.skuInfos) : '',
                DelSkuInfos: this.delSkuArr.length ? JSON.stringify(this.delSkuArr) : '',
                FwCheckTypes: this.row.FwCheckTypes,
            };
            this.loading = true;
            this.$ajax.post('app/to/fwwordmodifyv2', ajaxData).then((res) => {
                this.loading = false;
                if (res.Code !== 200) {
                    this.$message.warning(res.Msg);
                    return;
                }
                this.dialogVisible = false;
                this.$message.success('操作成功！');
                this.resetData();
                this.$emit('modifySuccess');
            });
        },
        codeListBan() {
            // 一键清除
            this.codeListBanShow = false;
            for (var i = 0; i < this.tipsObject.length; i++) {
                if (this.tipsObject[i].type === 'img') {
                    this.tipsObject[i].replaceAfter = '';
                }
            }
            this.$message.success('删除成功');
        },
        gotoWord(item) {
            if (this.description === '') {
                return;
            }
            // 点击违禁词跳到对应详情位置
            const target = `.modify-word-container .description-code #${item.index[item.currIndex]}`;
            const len = item.index.length;
            if (len > 1) {
                // 详情中有多个违禁词就轮流跳转
                if (item.currIndex + 1 === len) {
                    item.currIndex = 0; // 重置到第一个
                } else {
                    item.currIndex += 1; // +1
                }
            }
            try {
                document.querySelector(target).scrollIntoView({
                    behavior: 'smooth',
                });
            } catch {
                // do nothing
            }
        },
        resetData() {
            this.productionInfo = {};
            this.DetailFwImage = [];
            this.DetailFwText = [];
            this.DetailFwOne = [];
            this.tipsObject = [];
            this.subjectArr = [];
            this.codeListBanShow = true;
            this.description = '';
            this.delSkuArr = [];
            this.modifyAttributesArr = [];
            this.fwInfo = {};
            if (document.querySelector('.description')) {
                document.querySelector('.description').addEventListener('mouseover', this.mouseoverEvent, false);
            }
        },
        handleClose(done) {
            this.resetData();

            done();
        },

        getSkuInfos() {
            // 补偿sku规格的内容到属性中
            const sku = [];
            const key = {};
            if (this.productionInfo.SkuInfos != null && this.productionInfo.SkuInfos.length > 0) {
                for (let i = 0; i < this.productionInfo.SkuInfos[0].attributes.length; i++) {
                    key[this.productionInfo.SkuInfos[0].attributes[i].attributeID] =
                        this.productionInfo.SkuInfos[0].attributes[i].attributeValue;
                }
            }
            this.productionInfo.Attributes.forEach((item) => {
                if (key[item.attributeID]) {
                    sku.push(item);
                }
            });
            return JSON.parse(JSON.stringify(sku));
        },

        getAttributes(options, tips) {
            // 拼接属性
            let attributes = [];
            let customIndex = 0;
            if (options.AttrVals != undefined) {
                if (tips === 'confirm') {
                    for (var a = 0; a < options.AttrVals.length; a++) {
                        var _attr = options.AttrVals[a];
                        var _attrOpts;
                        if (_attr.isCustom) {
                            if (_attr.value != '' && _attr.name != '') {
                                _attrOpts = {
                                    attributeID: customIndex, // 属性ID long类型
                                    attributeName: _attr.name, // 属性名称 string
                                    valueID: 0, // 属性值ID long
                                    value: _attr.value, // 属性值  string
                                    isCustom: true, // 是否为自定义属性 boolean
                                };
                                attributes.push(_attrOpts);
                                customIndex = customIndex + 1;
                            }
                        } else if (_attr.value != '' && _attr.value != []) {
                            var attrValue = _attr.value;
                            if (attrValue instanceof Array) {
                                for (var av = 0; av < attrValue.length; av++) {
                                    _attrOpts = {
                                        attributeID: _attr.fid, // 属性ID long类型
                                        attributeName: _attr.name, // 属性名称 string
                                        valueID: _attr.vid[av], // 属性值ID long
                                        value: _attr.value[av], // 属性值  string 数组转成字符串类型
                                        isCustom: false, // 是否为自定义属性 boolean
                                    };
                                    attributes.push(_attrOpts);
                                }
                            } else {
                                _attrOpts = {
                                    attributeID: _attr.fid, // 属性ID long类型
                                    attributeName: _attr.name, // 属性名称 string
                                    valueID: _attr.inputType == 0 ? 0 : _attr.vid, // 属性值ID long
                                    value: attrValue, // 属性值  string 数组转成字符串类型
                                    isCustom: false, // 是否为自定义属性 boolean
                                };
                                attributes.push(_attrOpts);
                            }
                        }
                    }
                } else {
                    for (let a = 0; a < options.AttrVals.length; a++) {
                        const _attr = options.AttrVals[a];
                        let _attrOpts;
                        if (_attr.isCustom) {
                            if (_attr.name != '') {
                                _attrOpts = {
                                    attributeID: customIndex, // 属性ID long类型
                                    attributeName: _attr.name, // 属性名称 string
                                    valueID: 0, // 属性值ID long
                                    value: _attr.value, // 属性值  string
                                    isCustom: true, // 是否为自定义属性 boolean
                                };
                                attributes.push(_attrOpts);
                                customIndex = customIndex + 1;
                            }
                        } else {
                            const attrValue = _attr.value;
                            if (attrValue instanceof Array) {
                                for (let av = 0; av < attrValue.length; av++) {
                                    _attrOpts = {
                                        attributeID: _attr.fid, // 属性ID long类型
                                        attributeName: _attr.name, // 属性名称 string
                                        valueID: _attr.vid && _attr.vid[av], // 属性值ID long
                                        value: _attr.value && _attr.value[av], // 属性值  string 数组转成字符串类型
                                        isCustom: false, // 是否为自定义属性 boolean
                                    };
                                    attributes.push(_attrOpts);
                                }
                            } else {
                                _attrOpts = {
                                    attributeID: _attr.fid, // 属性ID long类型
                                    attributeName: _attr.name, // 属性名称 string
                                    valueID: _attr.inputType == 0 ? 0 : _attr.vid, // 属性值ID long
                                    value: attrValue, // 属性值  string 数组转成字符串类型
                                    isCustom: false, // 是否为自定义属性 boolean
                                };
                                attributes.push(_attrOpts);
                            }
                        }
                    }
                }
            }
            return attributes;
        },

        // 修改属性
        showModifyAttributes() {
            let that = this;
            const data = {
                productionInfo: this.productionInfo,
                attributeFwText: this.row.AttributesFw,
                attributeName: this.fwAttributeData.map((el) => el.attributeName),
                callBack: (res) => {
                    const Attributes = this.getAttributes(res, 'confirm');
                    Attributes.forEach((item) => {
                        that.fwAttributeData.forEach((el) => {
                            if (item.attributeName == el.attributeName) {
                                el.afterValue = item.value;
                            }
                        });
                    });
                    const skuInfos = this.getSkuInfos();
                    that.productionInfo.Attributes = Attributes.concat(skuInfos);

                    that.modifyAttributesArr = that.productionInfo.Attributes;

                    // that.productionInfo.Attributes.forEach((el) => {
                    //     that.fwInfo.productAttribute.forEach((val) => {
                    //         if (el.attributeID == val.attributeID && el.attributeName == val.attributeName) {
                    //             that.modifyAttributesArr.push(el);
                    //         }
                    //     });
                    // });
                },
            };
            this.$refs.modifyAttributes.show(data);
        },

        // 修改sku
        changeSku(row) {
            if (row.afterSkuWord.attributeValue) {
                row.handleType = 0;
            } else {
                row.handleType = -1;
            }
        },

        // 删除sku
        delSku(row) {
            row.handleType = 1;
            // this.delSkuArr.push(this.fwInfo.skuInfos[index]);
            // this.fwSkuData.splice(index, 1); // 页面展示
            // this.fwInfo.skuInfos.splice(index, 1); // 提交数据
        },
    },
};
</script>
<style lang="scss">
.modify-word-container {
    line-height: 1.5;
    .gray {
        color: #a5a5a5;
    }
    .blue {
        color: #0064c1;
    }
    .red {
        color: #ff0000;
    }
    .modify-word-title {
        display: inline-block;
        text-align: right;
        width: 88px;
    }
    .el-table--mini .el-table__cell {
        padding: 4px 0;
    }
    .modify-word-item {
        display: flex;
        align-items: center;
        & + .modify-word-item {
            margin-top: 10px;
        }
        .tags {
            padding: 5px 10px;
            cursor: pointer;
            border: 1px solid #dddddd;
            & + .tags {
                margin-left: 10px;
            }
        }
    }
    .description {
        margin-top: 15px;
        display: flex;
        .description-code {
            flex: 1;
            border: 1px solid rgb(221, 221, 221);
            height: 500px;
            overflow-y: auto;
            overflow-x: hidden;
            padding: 2px 5px;
            .codeModify {
                color: #ff0000;
            }
        }
        #operation-dom {
            position: fixed;
            top: 0;
            left: 0;
            width: 100px;
            z-index: 100000;
            align-items: center;
            border: 1px solid #aaaaaa;
            color: #999999;
            background: #fff;
            font-size: 14px;
            display: none;
            em {
                width: 50%;
                display: inline-block;
                height: 32px;
                line-height: 32px;
                padding-left: 18px;
                cursor: pointer;
                background-image: url('../../../assets/img/popupIcon.png');
            }
            .deleteBtn {
                background-position: -5px 5px;
                background-repeat: no-repeat;
                border-right: 1px solid #aaa;
            }
            .replaceBtn {
                background-position: -5px -19px;
                background-repeat: no-repeat;
            }
        }
    }
}
</style>
